// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	ITEM: '[data-fragment="BeerTiles.item"]',
};

export default class BeerTiles extends WebComponent {

	constructor (props) {
		super(props);
	}

	didMount() {
		const {
			cookieName,
		} = this.props;

		this.cookieName = cookieName;
		this.items = this.element.querySelectorAll(fragments.ITEM);

		let cookieValue = this.getCookie(this.cookieName);

		if(cookieValue === '1') {
			for(let i = 0; i < this.items.length; i++) {
				let item = this.items[i];
				let itemNonAlcoholicUrl = item.dataset.nonUrl;
				if(itemNonAlcoholicUrl !== '' && typeof(itemNonAlcoholicUrl) !== 'undefined') {
					item.setAttribute('href', itemNonAlcoholicUrl);
				}
			}
		}
	}

	getCookie(cName) {
		var name = cName + "=";
		var ca = document.cookie.split(';');
		for(var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
}

BeerTiles.defaultProps = {
	cookieName: 'rpbAgeCheck'
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/BeerTiles.js